import dayjs from "dayjs";
import { PrimeIcons } from "primereact/api";
import {
    InputMask,
    InputMaskCompleteEvent,
    InputMaskProps,
} from "primereact/inputmask";
import { END_OF_DAY_TIME, START_OF_DAY_TIME } from "../../constants";
import { isTimeValid } from "../../utils";
import { getDateFromTime } from "../../utils/date.utils";

interface TimeInputProps extends Omit<InputMaskProps, "onChange"> {
    minTime?: string;
    maxTime?: string;
    onChange?: (value?: string) => void;
    invalid?: boolean;
}

const TimeInput = (props: TimeInputProps) => {
    const { minTime, maxTime, onChange = () => {}, invalid, ...rest } = props;

    const isTimeWithinRange = (time: string) => {
        const currentTime = getDateFromTime(time);
        const min = getDateFromTime(minTime || START_OF_DAY_TIME);
        const max = getDateFromTime(maxTime || END_OF_DAY_TIME);

        return (
            dayjs(currentTime).isSameOrAfter(min) &&
            dayjs(currentTime).isSameOrBefore(max)
        );
    };

    const handleOnComplete = (event: InputMaskCompleteEvent) => {
        const inputValue = event.value || "";

        if (!isTimeValid(inputValue) || !isTimeWithinRange(inputValue)) {
            onChange("");
        }
    };

    return (
        <div className="p-inputgroup">
            <InputMask
                {...rest}
                mask="99:99"
                placeholder="HH:mm"
                onChange={(event) => onChange(event.value ?? undefined)}
                onComplete={handleOnComplete}
            />
            <span className="p-inputgroup-addon">
                <i className={PrimeIcons.CLOCK} />
            </span>
        </div>
    );
};

export default TimeInput;
